(function () {
  'use strict';
  var mobile = window.matchMedia('(max-width: 767px)');
  function cardsOf(track) {
    return Array.from(track.children).filter(function (card) { return !card.hasAttribute('data-round3-ui'); });
  }
  function currentIndex(track, cards) {
    var max = Math.max(0, track.scrollWidth - track.clientWidth);
    if (max < 2 || track.scrollLeft < 2) return 0;
    if (track.scrollLeft >= max - 2) return cards.length - 1;
    var origin = track.getBoundingClientRect().left + track.clientLeft;
    var distance = Infinity, selected = 0;
    cards.forEach(function (card, index) {
      var next = Math.abs(card.getBoundingClientRect().left - origin);
      if (next < distance) { distance = next; selected = index; }
    });
    return selected;
  }
  function timelineTabs(track, carousel) {
    if (track.__hmcWeekTabs) return;
    var cards = cardsOf(track);
    var nav = document.createElement('nav');
    nav.className = 'hmc-claude-week-tabs';
    nav.dataset.round3Ui = '';
    nav.setAttribute('aria-label', 'Choose a week');
    var tabs = cards.map(function (card, index) {
      var phase = card.querySelector('.hmc-week__k');
      var button = document.createElement('button');
      card.id = card.id || track.id + '-week-' + (index + 1);
      button.type = 'button';
      var label = phase ? phase.textContent.trim() : String(index + 1);
      var parts = label.match(/^(WEEKS)\s+(.+)$/);
      button.setAttribute('aria-label', label);
      if (parts) {
        var prefix = document.createElement('span');
        var range = document.createElement('span');
        prefix.className = 'hmc-claude-week-prefix';
        range.className = 'hmc-claude-week-range';
        prefix.textContent = parts[1];
        range.textContent = parts[2];
        button.append(prefix, document.createTextNode(' '), range);
      } else button.textContent = label;
      button.setAttribute('aria-controls', card.id);
      button.setAttribute('aria-current', index === 0 ? 'step' : 'false');
      button.addEventListener('click', function () { carousel.scrollToIndex(index); });
      button.addEventListener('keydown', function (event) {
        var next;
        if (event.key === 'ArrowRight') next = Math.min(cards.length - 1, index + 1);
        else if (event.key === 'ArrowLeft') next = Math.max(0, index - 1);
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = cards.length - 1;
        else return;
        event.preventDefault();
        tabs[next].focus();
        carousel.scrollToIndex(next);
      });
      nav.appendChild(button);
      return button;
    });
    track.before(nav);
    var stage = document.createElement('div');
    stage.className = 'hmc-r6-timeline-stage';
    track.before(stage);
    stage.appendChild(track);
    var arrows = document.createElement('div');
    arrows.className = 'hmc-r6-image-arrows';
    arrows.dataset.round3Ui = '';
    function arrow(label, glyph, change) {
      var button = document.createElement('button');
      button.type = 'button';
      button.textContent = glyph;
      button.setAttribute('aria-label', label);
      button.setAttribute('aria-controls', track.id);
      button.addEventListener('click', function () {
        carousel.scrollToIndex(currentIndex(track, cards) + change);
      });
      arrows.appendChild(button);
      return button;
    }
    var previous = arrow('Previous week', '‹', -1);
    var next = arrow('Next week', '›', 1);
    stage.appendChild(arrows);
    var dots = document.createElement('div');
    dots.className = 'hmc-r6-dots';
    dots.dataset.round3Ui = '';
    var dotButtons = cards.map(function (card, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', 'Go to ' + tabs[index].getAttribute('aria-label').toLowerCase());
      button.setAttribute('aria-controls', card.id);
      button.addEventListener('click', function () { carousel.scrollToIndex(index); });
      dots.appendChild(button);
      return button;
    });
    carousel.controls.prepend(dots);
    var frame = 0;
    function refresh() {
      frame = 0;
      var index = currentIndex(track, cards);
      cards.slice(index, index + 2).forEach(function (card) {
        var previewImage = card.querySelector('img');
        // Keep the formula image lazy; it loads when it approaches the viewport.
        if (previewImage && !/\/hmc-cf-w1-2\.webp(?:\?|$)/.test(previewImage.getAttribute('src') || '')) previewImage.loading = 'eager';
      });
      tabs.forEach(function (tab, i) { tab.setAttribute('aria-current', i === index ? 'step' : 'false'); });
      dotButtons.forEach(function (dot, i) { dot.setAttribute('aria-current', i === index ? 'step' : 'false'); });
      previous.disabled = index === 0;
      next.disabled = index === cards.length - 1;
      var img = cards[index].querySelector('img');
      if (mobile.matches && img) {
        var rect = img.getBoundingClientRect(), stageRect = stage.getBoundingClientRect();
        arrows.style.top = (rect.top - stageRect.top + rect.height / 2) + 'px';
      }
      nav.hidden = !mobile.matches;
      arrows.hidden = !mobile.matches;
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(refresh); }
    track.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    mobile.addEventListener('change', schedule);
    track.addEventListener('load', schedule, true);
    if ('ResizeObserver' in window) {
      var imageObserver = new ResizeObserver(schedule);
      cards.forEach(function (card) { var img = card.querySelector('img'); if (img) imageObserver.observe(img); });
    }
    // One subtle first-appearance hint. Never animate after input or for reduced motion.
    var interacted = false, animations = [];
    function stopHint() {
      interacted = true;
      animations.forEach(function (animation) { animation.cancel(); });
    }
    [stage, nav, carousel.controls].forEach(function (element) {
      element.addEventListener('pointerdown', stopHint, { passive: true });
      element.addEventListener('keydown', stopHint);
    });
    if ('IntersectionObserver' in window) {
      var hint = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        hint.disconnect();
        if (!mobile.matches || interacted || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        track.dataset.swipeHintPlayed = 'true';
        animations = cards.map(function (card) {
          return card.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-22px)', offset: .45 }, { transform: 'translateX(0)' }], { duration: 700, easing: 'ease-in-out' });
        });
      }, { threshold: .25 });
      hint.observe(stage);
    }
    track.__hmcWeekTabs = nav;
    refresh();
  }
  function activeHeight(track) {
    if (track.__hmcActiveHeight) return;
    var cards = cardsOf(track);
    if (!cards.length) return;
    var frame = 0;
    function refresh() {
      frame = 0;
      if (!mobile.matches) { track.style.removeProperty('height'); return; }
      var card = cards[currentIndex(track, cards)];
      var style = getComputedStyle(track);
      var extra = ['paddingTop', 'paddingBottom', 'borderTopWidth', 'borderBottomWidth'].reduce(function (sum, key) { return sum + (parseFloat(style[key]) || 0); }, 0);
      var height = Math.ceil(card.getBoundingClientRect().height + extra);
      if (height > 0 && track.style.height !== height + 'px') track.style.height = height + 'px';
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(refresh); }
    track.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    mobile.addEventListener('change', schedule);
    track.addEventListener('load', schedule, true);
    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(schedule);
      cards.forEach(function (card) { observer.observe(card); });
      track.__hmcActiveHeight = observer;
    } else track.__hmcActiveHeight = true;
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    refresh();
  }
  function init(root) {
    root = root || document.querySelector('.hmc[data-hmc]');
    if (!root || !root.dataset.hmcServerLayout || root.dataset.rsReady !== 'true' || !window.HmcRound3Carousel) return;
    ['#hmc-s16 .hmc-fails', '#hmc-s18 .hmc-weeks'].forEach(function (selector) {
      var track = root.querySelector(selector);
      if (!track || track.dataset.claudeCarousel) return;
      track.dataset.claudeCarousel = 'true';
      track.classList.add('hmc-claude-mobile-track');
      var timeline = selector.indexOf('s18') >= 0;
      var carousel = window.HmcRound3Carousel(root, track, { label: timeline ? 'Week by week' : 'Why previous routines failed' });
      if (!carousel) return;
      if (timeline) timelineTabs(track, carousel);
      function sync() {
        if (!mobile.matches) track.scrollTo({ left: 0, behavior: 'instant' });
        carousel.controls.hidden = !mobile.matches;
        carousel.refresh();
      }
      mobile.addEventListener('change', sync);
      sync();
    });
    ['#hmc-s16 .hmc-fails', '#hmc-s18 .hmc-weeks', '#hmc-s20 .hmc-studies', '#hmc-s25 .hmc-reasons', '#hmc-customer-reviews .hmc-claude-review-track'].forEach(function (selector) {
      var track = root.querySelector(selector);
      if (track) activeHeight(track);
    });
  }
  document.addEventListener('hmc:restyle-ready', function (event) { init(event.target); });
  document.addEventListener('shopify:section:load', function () { init(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }, { once: true });
  else init();
}());
